var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_674_1210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99986 0.961031L9.80392 6.42895C9.77925 7.14555 8.93165 7.4163 8.4077 6.87775C8.22773 6.69234 8.12903 6.44367 8.13774 6.19941L8.24369 3.20794L8.07824 3.37274L5.74442 5.70647L4.60799 6.83507L4.59928 6.8439L1.72265 9.70588C1.32207 10.1032 0.682009 10.0973 0.290137 9.69117C-0.101736 9.28652 -0.0959302 8.63613 0.303199 8.24031L4.43382 4.13201L6.82134 1.74679L3.87214 1.81006C3.62976 1.81595 3.38593 1.71294 3.20741 1.52754C2.84021 1.15085 2.86633 0.618182 3.15806 0.328305C3.28288 0.203232 3.4585 0.122302 3.66895 0.117887L9.06517 0.000171139C9.57461 -0.010129 10.0187 0.446022 9.99986 0.961031Z",
    fill: "#223D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74434 5.70605L4.66451 6.78463C4.6471 6.80229 4.62823 6.81995 4.60791 6.83466L5.74434 5.70605Z",
    fill: "#223D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07845 3.37256C8.05377 3.40493 8.0262 3.43583 7.99717 3.46526L5.74463 5.70628L8.07845 3.37256Z",
    fill: "#223D51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_674_1210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFile);
export default __webpack_public_path__ + "static/media/selectFile.e4e17d2fdf42fccabe724eeacd0b5143.svg";
export { ForwardRef as ReactComponent };